import MuiPopover, {
  PopoverProps as MuiPopoverProps,
} from "@mui/material/Popover";

import { TestProps } from "shared/types";

interface Props extends MuiPopoverProps, TestProps {}

const Popover = ({ testId, ...props }: Props) => (
  <MuiPopover data-testid={testId} {...props} />
);

export default Popover;
